import { render } from "./ReservationDetail.vue?vue&type=template&id=c8b642f0&scoped=true"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"

import "./ReservationDetail.vue?vue&type=style&index=0&id=c8b642f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b642f0"]])

export default __exports__